import css from './imageResource.module.scss';

import cx from 'classnames';
import { memo, useLayoutEffect, useState } from 'react';

import { useImageViewer } from 'com/ImageViewer';
import { apiGetResource } from 'core/api';
import { useMessageModal } from 'core/ui/MessageModal';
import Preloader from 'core/ui/Preloader';

type Props = {
  resourceUid: string;
  className?: string;
};
function ImageResource({ resourceUid, className }: Props) {
  const [url, setUrl] = useState<string | null>(cache.get(resourceUid) ?? null);
  const [loaded, setLoaded] = useState(cache.has(resourceUid));
  const { showError } = useMessageModal();

  useLayoutEffect(() => {
    if (!url) {
      apiGetResource(resourceUid).then(setUrl).catch(showError);
    }
  }, [resourceUid]);

  const imageViewer = useImageViewer();

  return (
    <div
      className={cx(css.root, className, url && css.imageInteractive)}
      onClick={url ? () => imageViewer.show(url) : undefined}
    >
      {url ? (
        <img
          src={url}
          className={css.image}
          onLoad={() => {
            cache.set(resourceUid, url);
            setLoaded(true);
          }}
          style={loaded ? undefined : { display: 'none' }}
          crossOrigin="use-credentials"
        />
      ) : (
        <Preloader className={css.imagePreloader} />
      )}
    </div>
  );
}

export default memo(ImageResource);

const cache = new Map<string, string>();
